import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    padding: theme.spacing(1, 1.5, 0, 1.5),
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
  },
  empty: {
    padding: theme.spacing(4),
    textAlign: "center",
  },
}));

/**
 * Container for a stacked <ListCard/> list: an optional leading control (e.g.
 * select-all), a total count, and an empty state.
 */
const ListCards = ({ count, noun, empty, action, children }) => {
  const classes = useStyles();
  const isEmpty = React.Children.count(children) === 0;
  const plural = count === 1 ? "" : "s";

  return (
    <>
      <div className={classes.header}>
        <div>{action}</div>
        {typeof count === "number" && (
          <Typography variant="body2" color="textSecondary">
            {count} {noun}
            {plural}
          </Typography>
        )}
      </div>
      <div className={classes.list}>
        {isEmpty ? (
          <Typography className={classes.empty} color="textSecondary">
            {empty}
          </Typography>
        ) : (
          children
        )}
      </div>
    </>
  );
};

ListCards.propTypes = {
  count: PropTypes.number,
  noun: PropTypes.string,
  empty: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default ListCards;
